
interface KisaraSectionProps {
  language: 'es' | 'en';
}

export default function KisaraSection({ language }: KisaraSectionProps) {
  const content = {
    es: {
      title: 'Conoce a Kisara',
      subtitle: 'Co-fundadora de First Step Japan',
      description: 'Japonesa nacida en Osaka, apasionada por conectar con personas de todo el mundo y ayudarles a integrarse con empatía y comprensión.',
      mission: 'Mi misión es hacer que Japón se sienta como tu hogar, no solo un destino. Trabajo junto a Juampi para ofrecer una experiencia cálida, confiable y humana desde el primer día.',
      stat1: 'Coordinación con oficinas municipales y servicios locales',
      stat2: 'Traducción y acompañamiento cultural',
      stat3: 'Asistencia en vivienda, salud y vida práctica',
      stat4: 'Comunicación directa con clientes en japonés'
    },
    en: {
      title: 'Meet Kisara',
      subtitle: 'Co-founder of First Step Japan',
      description: 'Born and raised in Osaka, Kisara is passionate about connecting with people from around the world and helping them adapt to Japanese life with empathy and care.',
      mission: 'Her mission is to make Japan feel like your home, not just a destination. She works alongside Juampi to provide a warm, trustworthy, and human experience from day one.',
      stat1: 'Coordination with city offices and local services',
      stat2: 'Cultural translation and support',
      stat3: 'Assistance with housing, healthcare, and daily needs',
      stat4: 'Client communication in Japanese'
    }
  };

  return (
    <section className="py-20 bg-gradient-to-br from-pink-50 via-white to-yellow-50 relative overflow-hidden">
      {/* Subtle Japanese Pattern Background */}
      <div className="absolute inset-0 opacity-5">
        <div className="absolute top-10 left-10 text-6xl">🌸</div>
        <div className="absolute top-32 right-20 text-4xl">🌸</div>
        <div className="absolute bottom-20 left-32 text-5xl">🌸</div>
        <div className="absolute bottom-40 right-10 text-3xl">🌸</div>
        <div className="absolute top-1/2 left-1/4 text-4xl">🌸</div>
        <div className="absolute top-1/3 right-1/3 text-3xl">🌸</div>
      </div>

      <div className="container mx-auto px-4 relative z-10">
        <div className="max-w-6xl mx-auto">
          {/* Section Header */}
          <div className="text-center mb-16">
            <h2 className="text-4xl md:text-5xl font-bold text-red-600 mb-4">
              {content[language].title} 🌸
            </h2>
            <p className="text-xl text-red-700 font-medium">
              {content[language].subtitle}
            </p>
          </div>

          <div className="grid lg:grid-cols-2 gap-12 items-center">
            {/* Content - Left side for Kisara */}
            <div className="space-y-6 lg:order-1">
              <div className="space-y-4">
                <p className="text-lg text-gray-700 leading-relaxed">
                  {content[language].description}
                </p>
                <p className="text-lg text-gray-700 leading-relaxed">
                  {content[language].mission}
                </p>
              </div>

              {/* Stats */}
              <div className="grid grid-cols-1 gap-4 pt-6">
                <div className="flex items-center p-4 bg-white rounded-xl shadow-md">
                  <div className="text-2xl mr-4">🌸</div>
                  <div className="text-sm text-gray-700 font-medium">{content[language].stat1}</div>
                </div>
                <div className="flex items-center p-4 bg-white rounded-xl shadow-md">
                  <div className="text-2xl mr-4">💬</div>
                  <div className="text-sm text-gray-700 font-medium">{content[language].stat2}</div>
                </div>
                <div className="flex items-center p-4 bg-white rounded-xl shadow-md">
                  <div className="text-2xl mr-4">🏠</div>
                  <div className="text-sm text-gray-700 font-medium">{content[language].stat3}</div>
                </div>
                <div className="flex items-center p-4 bg-white rounded-xl shadow-md">
                  <div className="text-2xl mr-4">🤝</div>
                  <div className="text-sm text-gray-700 font-medium">{content[language].stat4}</div>
                </div>
              </div>
            </div>

            {/* Image - Right side for Kisara */}
            <div className="relative lg:order-2">
              <div className="relative overflow-hidden rounded-2xl shadow-2xl">
                <img
                  src="https://static.readdy.ai/image/48ff209ee73fb0e306febf7d6a2e4fef/9e277e07ca8f4175121812b9ac690cc3.jpeg"
                  alt="Kisara - Co-fundadora de First Step Japan"
                  className="w-full h-auto object-cover object-top"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-pink-600/20 to-transparent"></div>
              </div>
              
              {/* Decorative Elements */}
              <div className="absolute -top-4 -right-4 w-16 h-16 bg-pink-400 rounded-full flex items-center justify-center text-2xl shadow-lg">
                🌸
              </div>
              <div className="absolute -bottom-4 -left-4 w-16 h-16 bg-red-600 rounded-full flex items-center justify-center text-2xl shadow-lg">
                🇯🇵
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
